export default __webpack_public_path__ + "static/media/create_hub_prac.625a1fc2.svg";